import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GenaralRuleField,
  Operator
} from "@/modules/GeneralRules/models/GenaralRuleField.model";
import { StopCondition } from "@/modules/GeneralRules/models/StopCondition.model";
import DisplayValue from "../DisplayValue/DisplayValue.vue";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import {
  CHANGE_OPERATOR,
  GENERAL_RULES_CONSTANTS,
  INPUT_TYPE
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";

Vue.use(Vuetify);

@Component({
  name: "StopConditionComponent",
  components: {
    DisplayValue
  }
})
export default class StopConditionComponent extends Vue {
  @Prop() private stopConditionProp!: StopCondition;
  @Prop() private fields!: GenaralRuleField[];
  @Prop() private indexProp!: number;

  cardClass = STYLE_CLASSES.CARD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  DELETE_CONDITIOn = GENERAL_RULES_CONSTANTS.TOOLTIP.DELETE_CONDITION;

  requiredField = [this.handleRules];
  stopCondition: StopCondition = {
    key: "",
    operator: "",
    value: "",
    active: true
  };
  operators: Operator[] = [];
  index = 0;
  isEditing = false;
  indexChanged = -1;

  mounted() {
    if (this.stopConditionProp) {
      this.onChangeStopConditionProp();
    }
  }

  @Watch("stopConditionProp")
  onChangeStopConditionProp() {
    this.isEditing = true;
    this.setOperatorsList(this.stopConditionProp.key);
    this.stopCondition = { ...this.stopConditionProp };
    this.index = this.indexProp;
  }

  @Watch("stopCondition.operator", { deep: true })
  onChangeStopCondition() {
    if (this.stopCondition.operator == CHANGE_OPERATOR.key) this.setValue("");
  }

  setValue(value: any) {
    this.handleRules(value);
    if (value) {
      this.stopCondition.value = value;
    }
    if (!this.isEditing)
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.ADD_STOP_CONDITION, {
        ...this.stopCondition
      });
    else
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.UPDATE_STOP_CONDITION,
        { ...this.stopCondition },
        this.index
      );
  }

  setOperatorsList(key: string) {
    const field = this.fields.find(field => field.key == key);
    if (field && field.display !== INPUT_TYPE.TEXT)
      this.operators = [...field.operators];
    else this.operators = [CHANGE_OPERATOR];
  }

  setOperator(key: string) {
    const operator = this.operators.find(field => field.key == key);
    if (operator) {
      this.stopCondition.operator = operator.key;
    }
    this.indexChanged = this.index;
  }

  deleteStopConditions() {
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.DELETE_STOP_CONDITION,
      this.index
    );
  }

  handleRules(v: string) {
    if (
      (v && (Array.isArray(v) ? (v.length > 0 ? true : false) : true)) ||
      this.stopCondition.operator == CHANGE_OPERATOR.key
    ) {
      if (this.stopCondition.operator)
        this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.ENABLE_SAVE_BTN);
      return true;
    } else {
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.DISABLE_SAVE_BTN);
      return FORM_MESSAGES.REQUIRED_FIELD;
    }
  }
  setTimeUnit(timeUnit: any) {
    if (timeUnit) {
      this.stopCondition.timeUnit = timeUnit;
    }
    if (!this.isEditing)
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.ADD_STOP_CONDITION, {
        ...this.stopCondition
      });
    else
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.UPDATE_STOP_CONDITION,
        { ...this.stopCondition },
        this.index
      );
  }
}
